import React, { PropTypes } from 'react';
import Text from 'components/Page/PageComponents/Text/Text';

const Ingress = ({ children }) => {
  const style = require('./Ingress.scss');
  return <Text innerStyle={style.ingress}>{children}</Text>;

};

Ingress.propTypes = {
  children: PropTypes.string
};

export default Ingress;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Ingress/Ingress.js
 **/